import axios from 'axios'

const AI_AGENT_URL = import.meta.env.VITE_AI_AGENT_API_URL || ''

const aiChatApi = axios.create({
  baseURL: `${AI_AGENT_URL}/api/dashboard`,
  headers: { 'Content-Type': 'application/json' },
})

export default aiChatApi
